import React, { useEffect, useRef, useState } from 'react';
import { Tooltip } from '@mui/material';
import { CellText } from '../TableSelectFieldv2/styles';

interface EllipsisTooltipCellProps {
  title: string;
  isDisabled: boolean;
  children: React.ReactNode;
}

const EllipsisTooltipCell = ({ title, isDisabled, children }: EllipsisTooltipCellProps) => {
  const textRef = useRef<HTMLSpanElement>(null);
  const [isEllipsized, setIsEllipsized] = useState(false);

  useEffect(() => {
    const element = textRef.current;
    if (!element) return;

    const checkEllipsis = () => {
      setIsEllipsized(element.scrollWidth > element.clientWidth);
    };

    checkEllipsis();

    window.addEventListener('resize', checkEllipsis);
    return () => window.removeEventListener('resize', checkEllipsis);
  }, [title, children]);

  return (
    <Tooltip title={isEllipsized ? title : ''} arrow placement="top">
      <CellText ref={textRef} isDisabled={isDisabled}>
        {children}
      </CellText>
    </Tooltip>
  );
};

export default EllipsisTooltipCell;
